import React from "react";
import "./Feature1.css";
import feature1Image from "../../assets/feature1.png";
import YouTube from "react-youtube";

const Feature1 = () => {

  let youtubeWidth = 0

  if (window.innerWidth > 700) {
    youtubeWidth = "640";
  }
  else {
    youtubeWidth = window.innerWidth;
  }

  const opts = {
    height: "390",
    width: youtubeWidth,
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  function onReady(event) {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  }

  return (
    <div
      className="gpt3__possibility section__padding"
      id="videos"
      style={{ backgroundColor: "#3A3A3A" }}
    >
      <div className="gpt3__possibility-image">
        <YouTube videoId="og0iaua8LmM" opts={opts} onReady={onReady} />
        {/* <img src={feature1Image} alt='feature'/> */}
      </div>

      <div className="gpt3__possibility-content">
        <h1 style={{ color: "white", fontWeight: "bold" }}>
          EMBEDDED LINUX
        </h1>
        {/* <h1 className="gradient__text">The possibilities are <br /> beyond your imagination</h1> */}
        <p style={{ color: "white", fontWeight: 'bold' }}>
        Using GDB to debug C program crash ( segmentation fault ). GDB tutorial
        </p>
        <h4></h4>
      </div>
    </div>
  );
};

export default Feature1;
